import rpcManagers from './rpc/rpcManagers';

/**
 * Get manager by ID
 * Now uses RPC: /api/:company/rpc/managers/get-by-id
 */
export async function getManagerById(company: string, managerId: string) {
  const { data } = await rpcManagers.getById(managerId);
  // RPC returns { ok: true, data } or { ok: false, error }
  if (data.ok) {
    return data.data;
  }
  throw new Error(data.error || 'Failed to load manager profile');
}

/**
 * Update manager
 * Now uses RPC: /api/:company/rpc/managers/update
 */
export async function updateManager(
  company: string,
  managerId: string,
  payload: {
    fullName?: string;
    email?: string;
    phone?: string;
    permissions?: string[];
  }
) {
  const { data } = await rpcManagers.update(managerId, payload);
  // RPC returns { ok: true, data } or { ok: false, error }
  if (data.ok) {
    return data.data;
  }
  throw new Error(data.error || 'Failed to update manager profile');
}

/**
 * Change manager password
 * Now uses RPC: /api/:company/rpc/managers/change-password
 */
export async function changeManagerPassword(company: string, managerId: string, newPassword: string) {
  const { data } = await rpcManagers.changePassword(managerId, newPassword);
  // RPC returns { ok: true, data } or { ok: false, error }
  if (data.ok) {
    return data.data;
  }
  throw new Error(data.error || 'Failed to change manager password');
}

